import React, { useState } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  NumberInput,
  NumberInputField,
  VStack,
} from '@chakra-ui/react';

const WarehouseFormModal = ({ isOpen, onClose, onSubmit }) => {
  const [name, setName] = useState('');
  const [quantity, setQuantity] = useState(0);
  const [minQuantity, setMinQuantity] = useState(0);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleInternalClose = () => {
    setName('');
    setQuantity(0);
    setMinQuantity(0);
    onClose();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!name.trim()) return;
    setIsSubmitting(true);
    try {
      const payload = {
        name: name.trim(),
        quantity: Number(quantity) || 0,
        minQuantity: Number(minQuantity) || 0,
      };
      await onSubmit(payload);
      setName('');
      setQuantity(0);
      setMinQuantity(0);
      onClose();
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={handleInternalClose} isCentered>
      <ModalOverlay />
      <ModalContent bg='#2d3748' color='white'>
        <ModalHeader>Nuovo prodotto</ModalHeader>
        <ModalCloseButton />
        <ModalBody as='form' onSubmit={handleSubmit}>
          <VStack spacing={4} align='stretch'>
            <FormControl isRequired>
              <FormLabel>Nome prodotto</FormLabel>
              <Input
                placeholder='Es. Birra'
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </FormControl>
            <FormControl>
              <FormLabel>Quantità iniziale</FormLabel>
              <NumberInput min={0}>
                <NumberInputField
                  value={quantity}
                  onChange={(e) => setQuantity(e.target.value)}
                />
              </NumberInput>
            </FormControl>
            <FormControl>
              <FormLabel>Soglia minima</FormLabel>
              <NumberInput min={0}>
                <NumberInputField
                  value={minQuantity}
                  onChange={(e) => setMinQuantity(e.target.value)}
                />
              </NumberInput>
            </FormControl>
          </VStack>
        </ModalBody>
        <ModalFooter>
          <Button  mr={3} onClick={handleInternalClose}>
            Annulla
          </Button>
          <Button  onClick={handleSubmit} isLoading={isSubmitting}>
            Salva
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default WarehouseFormModal;

